import { Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SortDirection, SourcingEventSortField, useListEventsForBuyerQuery } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { EventStatusTag } from "../../../sourcing-events/EventStatusTag";
import { useEventNavigation } from "../../../sourcing-events/useEventNavigation";
import { ACTIVE_V2_STATUSES, eventStatusTagInput, eventsCreatedBy, isDeadlineSoon } from "../homeEventStatuses";
import { HomePanel } from "./HomePanel";

// Over-fetch, then filter to mine and slice to DISPLAY_LIMIT.
const FETCH_LIMIT = 50;
const DISPLAY_LIMIT = 6;

export const ActiveProcurementsPanel = () => {
  const { t } = useTranslation();
  const authState = useLoggedInWithOrgContextState();
  const displayDate = useDisplayDate();
  const navigateToEvent = useEventNavigation();

  const { data, isLoading, isError } = useListEventsForBuyerQuery({
    orgId: authState.selectedOrg.id,
    statuses: ACTIVE_V2_STATUSES,
    sortBy: SourcingEventSortField.Deadline,
    sortDirection: SortDirection.Asc,
    limit: FETCH_LIMIT,
  });
  const events = eventsCreatedBy(data?.events ?? [], authState.me.id).slice(0, DISPLAY_LIMIT);

  return (
    <HomePanel titleKey="My active procurements" seeAllTo={urls.v2.sourcingEvents.viewAll} isLoading={isLoading} isError={isError} isEmpty={events.length === 0} emptyKey="No active procurements yet">
      <Table variant="simple" size="sm">
        <Thead><Tr><Th>{t("Title")}</Th><Th>{t("Status")}</Th><Th>{t("Deadline")}</Th></Tr></Thead>
        <Tbody>
          {events.map((event) => {
            const tag = eventStatusTagInput(event);
            const soon = isDeadlineSoon(event.deadline);
            return (
              <Tr key={event.id} cursor="pointer" _hover={{ bg: "smPrimarySofter" }} onClick={() => navigateToEvent(event)}>
                <Td fontWeight="medium" color="smText">{event.title || t("Untitled")}</Td>
                <Td>{tag && <EventStatusTag event={tag} size="sm" />}</Td>
                <Td>
                  <Text fontSize="sm" color={soon ? "smError" : "smMuted"} fontWeight={soon ? "semibold" : "normal"}>
                    {event.deadline ? displayDate(event.deadline) : "—"}
                  </Text>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </HomePanel>
  );
};
